import Vue from 'vue'
import App from './App.vue'
import router from './router/routers'
import './router/index'
import VueParticles from 'vue-particles'  
Vue.use(VueParticles)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

